function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* global __webpack_modules__ */

/* eslint-disable camelcase, no-underscore-dangle, no-multi-assign, consistent-return */

/**
 * Module dependencies
 */
const React = require('react');

const componentsReady = [];
/**
 * Check that webpack is ready and the modules can be load
 * @param {Function} resolveWeak
 * @returns {Number}
 */

const getWebpackModuleId = resolveWeak => {
  if (typeof __webpack_modules__ !== 'object') {
    return null;
  }

  const moduleId = resolveWeak();

  if (typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined') {
    return moduleId;
  }

  return null;
};
/**
 * Get the React Component wrapping the actual component
 * @param resolve
 * @param webpack
 * @returns {AsyncRouteComponent}
 */


const generateAsyncComponent = ({
  resolve,
  webpack
}) => {
  let Component = null;

  function init() {
    return resolve().then(c => {
      Component = c;
      return c;
    }).catch(() => Component);
  } // As soon as the module starts and is webpackReady load the component


  if (typeof webpack === 'function') {
    const moduleId = getWebpackModuleId(webpack); // preloadAsyncComponent only admits to load 1 Async component

    if (moduleId) {
      componentsReady.push(new Promise(resolveFn => init().then(() => resolveFn(moduleId))));
    }
  }
  /**
   * Real React Component that is loaded async
   */


  return class AsyncComponent extends React.PureComponent {
    static preload() {
      return init();
    }

    constructor(props) {
      super(props);
      this.state = {
        Component
      };
    }

    render() {
      const {
        Component: ComponentFromState
      } = this.state;

      if (ComponentFromState) {
        return React.createElement(ComponentFromState, this.props);
      }

      return null;
    }

  };
};
/**
 * Expose generateAsyncComponent
 */


exports = module.exports = generateAsyncComponent;
/**
 * Initialize Components from Webpack
 * @returns {Promise}
 */

const preloadAsyncComponent = () => {
  let promise = [];

  if (componentsReady.length > 0) {
    promise = componentsReady;
  }

  return Promise.all(promise).then(modules => modules);
};
/**
 * Expose preloadAsyncComponent
 */


exports.preloadReady = preloadAsyncComponent;

if (process.env.NODE_ENV === 'test') {
  exports.componentsReady = componentsReady;
}
/**
 * This method build all routes for SPA,
 * so that the data would be loaded before the route handler was rendered
 * @function
 * @param {Array} componentRoutes - The component routes
 * @returns {Array}
 */


const buildAsyncRoutes = (componentRoutes = []) => componentRoutes.filter(componentRoute => componentRoute.path && componentRoute.resolve && componentRoute.webpack).map((_ref) => {
  let {
    path,
    resolve,
    webpack
  } = _ref,
      extra = _objectWithoutProperties(_ref, ["path", "resolve", "webpack"]);

  return _objectSpread({}, extra, {
    path,
    component: generateAsyncComponent({
      resolve,
      webpack
    })
  });
});
/**
 * Expose buildAsyncRoutes
 */


exports.buildRoutes = buildAsyncRoutes;
